<template>

  <div class="jumbotron">
    <h1 class="display-4">403 - Non autorisé</h1>
    <p class="lead">Vous n'êtes pas autorisé(e) à accéder à cette page!</p>
    <hr class="my-4">
    <p>Rentrez en contact avec l'administrateur du système pour avois accés à la page visé.</p>
    <p class="lead">
      <a class="btn btn-primary btn-lg" href="/" role="button">Retourner à page principale</a>
    </p>
  </div>

</template>

<script>
export default {
  name: 'Unauthorized',
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Unauthorized.vue